import { useConditionComparatorFieldPath } from '../fieldPaths';
import { useController } from '../../../contexts';

export const useConditionComparatorController = () => {
  const fieldPath = useConditionComparatorFieldPath();
  return useController({ name: fieldPath, rules: { required: true } });
};
